import React from 'react'
import styled from 'styled-components'

interface Props {
  color?: string
  className?: string
}

export const Separator: React.FC<Props> = ({ color, className }) => {
  return <StyledSeparator className={className} color={color}></StyledSeparator>
}

interface Props {
  color?: string
}

const StyledSeparator = styled.div<Props>`
  margin-bottom: 1rem;
  border-bottom: 1px solid
    ${({ theme, color }) => color || theme.color.neutri.grigio};
`
